// =============================================================================
// `buildClientSnapshot` — embed a denormalized client row on bills/payments.
// =============================================================================

import { Client, ClientSnapshot } from "./types";

export const buildClientSnapshot = (c: Client): ClientSnapshot => ({
  id: c.id,
  companyName: c.companyName,
  companyNameLower: c.companyNameLower,
  name: c.name ?? null,
  lastname: c.lastname ?? null,
  personType: c.personType ?? null,
  documentId: c.documentId ?? null,
  category: c.category ?? null,
});
